import React from "react";
import { MainBg } from "../layouts/MainBg";
import cta_bg from "../assets/home/cta_bg.png";
import appstore_download from "../assets/icons/app-store-download.png";
import playtore_download from "../assets/icons/play-store-download.png";
import ai_icon from "../assets/icons/ai-icon.png";
import fireicon from "../assets/icons/fire.png";
import change_fast_goal from "../assets/home/change-fast-goal.png";
import home_slid_2 from "../assets/home/home-slide-2.png";
import all_in_one_ai from "../assets/home/all-in-one-ai.png";
import {
  PiChartBarBold,
  PiForkKnifeBold,
  PiLockBold,
  PiRobotBold,
} from "react-icons/pi";
import { LuAlarmClockCheck, LuBrain } from "react-icons/lu";

import { ANDROID_URL, IOS_URL, WEB_FUNNEL_URL } from "../config/ApiCollection";

const Home = () => {
  return (
    <MainBg>
      <div className="flex justify-center">
        <main className="w-[90%] ">
          {/* Section - 1 */}
          <section className="flex flex-col md:flex-row items-center justify-center text-white  ">
            {/* Left Section */}
            <div className="w-full md:w-1/2 flex flex-col items-start lg:order order-1">
              <div className="flex items-center">
                <h2 className="text-3xl sm:text-4xl md:text-5xl lg:text-7xl font-bold text-gray-900 leading-tight md:text-left text-left">
                  Smarter fasting. Simpler tracking.
                </h2>
              </div>
              <p className="text-lg text-gray-500 mt-8">
                FastMate is your AI-powered intermittent fasting and calorie
                tracking app. Log meals effortlessly using voice, photo, barcode
                scan, or manual entry. Track fasts, monitor calories, and get
                personalized insights — all in one place.
              </p>
              {/* App Store Buttons */}
              <div className="mt-8 flex flex-col lg:flex-row md:flex-col items-center gap-6 sm:gap-4  rounded-xl w-full justify-center">
                <div className="flex flex-col sm:flex-row lg:flex-row md:flex-col gap-4 sm:gap-5 w-full sm:w-auto justify-start sm:justify-star">
                  <a
                    href={IOS_URL}
                    className="md:w-1/3 w-[80%] bg-black rounded-[10px]"
                  >
                    <img src={appstore_download} className="rounded-[10px]" />
                  </a>
                  <a
                    href={ANDROID_URL}
                    className="md:w-1/3 w-[80%] bg-black rounded-[10px] content-center"
                  >
                    <img src={playtore_download} className="rounded-[10px]" />
                  </a>
                </div>
              </div>
            </div>
            {/* Right Section */}
            <div className="relative w-full md:w-1/2 flex justify-center lg:order-1 order">
              <img
                src={home_slid_2} // Ensure this image exists in the public folder or update the path
                alt="Fastmate"
                width={600}
                height={800}
                className="object-cover"
              />
            </div>
          </section>

          {/*  section 2  */}
          <section
            className="bg-[#FFFBEF] rounded-[30px] border border-themecolor pt-12 px-4 md:px-10 my-16"
            id="how-it-works"
          >
            <div className="max-w-7xl mx-auto flex flex-col md:flex-row items-center gap-10">
              {/* Left Side */}
              <div className="md:w-1/2 w-full text-center md:text-left order-1 md:order">
                <div className="text-[#FA5300] font-semibold mb-4 text-sm md:text-base hidden md:block">
                  <img
                    src={ai_icon}
                    className="w-7 mb-2 mx-auto md:mx-0"
                    alt="AI Icon"
                  />
                  <div className="inline-block">
                    "Smarter fasting.
                    <br /> Simpler tracking. Real results."
                  </div>
                </div>
                <img
                  src={change_fast_goal}
                  alt="FastMate App"
                  className="mx-auto md:mx-0 w-full max-w-[320px] sm:max-w-lg "
                />
              </div>

              {/* Right Side */}
              <div className="md:w-1/2 w-full flex flex-col gap-6 order md:order-1">
                <h2 className="text-2xl sm:text-3xl font-bold text-[#1E1E1E] leading-snug text-left md:text-left">
                  A smarter way to reach your health goals — without the
                  overwhelm.
                </h2>

                {/* Feature Cards */}
                <div className="flex flex-col sm:flex-row flex-wrap gap-4">
                  {/* Feature 1 */}
                  <div className="bg-white border border-[#FFD7C2] rounded-xl p-5 flex-1 min-w-[260px]">
                    <div className="bg-[#FA5300] text-white p-2 rounded-lg w-10 h-10 flex items-center justify-center mb-3">
                      <LuAlarmClockCheck size={20} />
                    </div>
                    <h3 className="font-bold text-lg mb-2">
                      Fasting & Calorie Tracking Made Simple
                    </h3>
                    <p className="text-gray-600 text-sm leading-relaxed">
                      Get science-backed fasting plans like 16:8, 18:6,
                      OMAD—plus effortless, AI-powered calorie and macro
                      tracking.
                    </p>
                  </div>

                  {/* Feature 2 */}
                  <div className="bg-white border border-[#FFD7C2] rounded-xl p-5 flex-1 min-w-[260px]">
                    <div className="bg-[#FA5300] text-white p-2 rounded-lg w-10 h-10 flex items-center justify-center mb-3">
                      <LuBrain size={20} />
                    </div>
                    <h3 className="font-bold text-lg mb-2">
                      Smart Food Logging with AI
                    </h3>
                    <p className="text-gray-600 text-sm leading-relaxed">
                      Log meals your way—snap, scan, speak, or type. FastMate’s
                      smart food recognition makes calorie tracking fast, easy,
                      and accurate.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </section>

          {/* Section - 3 */}

          <section
            className="flex flex-col md:flex-row items-center w-full rounded-2xl my-16 justify-self-center gap-10"
            id="why-fast-mate"
          >
            {/* Left Content */}
            <div className="md:w-1/2 text-left px-6 md:px-12 bg-[#FFFBEF] rounded-[40px] py-16 md:h-[658px] h-auto sm:h-auto content-center w-full">
              <h2 className="text-3xl sm:text-3xl md:text-4xl lg:text-4xl font-semibold text-gray-900 leading-tight md:text-left text-left">
                All-in-One Wellness,
                <br /> Backed by AI
              </h2>

              <div className="mt-6 space-y-6">
                {[
                  {
                    title: "",
                    icon: <PiForkKnifeBold size={20} />,
                    desc: "All-in-One Fasting & Nutrition Tracking",
                  },
                  {
                    title: "",
                    icon: <PiChartBarBold size={20} />,
                    desc: "Clear and Simple Progress Insights",
                  },
                  {
                    title: "",
                    icon: <PiRobotBold size={20} />,
                    desc: "Personalized Support from Your AI Coach",
                  },
                  {
                    title: "",
                    icon: <PiLockBold size={20} />,
                    desc: "Data Privacy You Can Trust",
                  },
                ].map((feature, index) => (
                  <div key={index} className="flex items-start gap-4 sm:gap-3">
                    <div className="p-1 text-white rounded-lg bg-[linear-gradient(0deg,_#EB5307_15.13%,_#FFFBEF_302.5%)]">
                      {feature.icon}
                    </div>
                    <p className="text-base sm:text-lg text-gray-800">
                      <span className="font-semibold">{feature.title} </span>
                      {feature.desc}
                    </p>
                  </div>
                ))}
              </div>

              {/* App Store Buttons */}
              <div className="mt-16 flex flex-col lg:flex-row md:flex-col items-center gap-6 sm:gap-4 rounded-xl w-full justify-between ">
                <div className="text-center sm:text-left ">
                  <a
                    href={ANDROID_URL}
                    className="bg-[#FA5300] hover:bg-orange-600 text-white font-bold py-2 px-6 rounded-xl text-4xl sm:text-3xl xs:text-2xl w-full sm:w-auto text-center"
                  >
                    Download App
                  </a>
                </div>

                <div className="flex flex-col sm:flex-row lg:flex-row md:flex-col gap-4 sm:gap-5 w-full sm:w-auto justify-center sm:justify-star lg:block hidden">
                  <img
                    src={fireicon}
                    height={60}
                    width={60}
                    className="content-center"
                  />
                </div>
              </div>
            </div>

            {/* Right Image */}
            <div className="md:w-1/2 flex justify-center mt-0 md:mt-0 md:py-16 p-0">
              <img
                src={all_in_one_ai}
                alt="App Preview"
                className="max-w-full md:w-[661px] w-full h-auto"
              />
            </div>
          </section>

          {/* footer cta  */}
          <section
            className="relative bg-[#222] bg-opacity-90 text-white md:py-16 py-4 md:px-6 px-3 text-center  rounded-[30px]  md:my-16 my-4"
            style={{
              backgroundImage: `url(${cta_bg})`,
              backgroundSize: "cover",
            }}
          >
            {/* Top Icons Background */}
            <div className="absolute top-0 left-0 w-full h-24  bg-no-repeat bg-center" />

            {/* Dark Overlay with Pattern */}
            <div className="relative py-16 md:px-6 px-3 rounded-xl">
              <h2 className="text-3xl md:text-4xl font-bold">
                Start Your Wellness Journey
              </h2>
              <p className="text-lg text-gray-300 mt-2">
                FastMate brings together what your body needs — clarity, rhythm,
                and ease.
              </p>

              {/* Call to Action Button */}
              <a href={WEB_FUNNEL_URL}>
                <button className="mt-6 bg-themebg hover:bg-blackbg text-4xl text-white px-12 py-3 font-bold rounded-xl  space-x-2 transition">
                  <span>Get Started</span>
                </button>
              </a>
            </div>
          </section>
        </main>
      </div>
    </MainBg>
  );
};

export default React.memo(Home);
